//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Balloon from '/react4xp/components/Balloon'
import Mask from '/react4xp/components/Mask'
import Image from '/react4xp/components/Image'
import Button from '/react4xp/components/Button'
import Video from '/react4xp/components/Video'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface CampaignHeroProps {
    bgColor?: string
    title?: string
    text?: string
    button?: {
        text?: string
        href: string
        external?: boolean
    }
    assets: {
        image: string
        alt?: string
    }
    image?: {
        src?: string
        srcMedium?: string
        alt?: string
    }
    video?: {
        videoType: 'youtube' | 'vimeo' | 'default'
        playText: string
        poster?: string
        posterMedium?: string
        url: string
    }
}

export default function CampaignHero({
    bgColor,
    title,
    text,
    button,
    assets,
    image,
    video
}: CampaignHeroProps) {
    return (
        <Section
            bgColor={bgColor}
            paddingTop='small'
        >
            <div className='container'>
                <div className={clsx('campaign-hero', image?.src && 'campaign-hero--has-image')}>
                
                    <div className='campaign-hero__top'>

                        {isNonWhitespaceString(title) && (
                            <div className='white-balloon'>
                                <Balloon
                                    arrow='bottom-left'
                                    arrowSize='medium'
                                    arrowSide='right'
                                    balloonSide='left'
                                    balloonColor='white'
                                    spacing='small'
                                >
                                    <h1 className='h1-hero-small'>
                                        {title}
                                    </h1>
                                </Balloon>
                            </div>
                        )}

                        {isNonWhitespaceString(image?.src) ? (
                            <>

                                <Mask className='image'>
                                    <Image
                                        src={image?.src}
                                        srcMedium={image?.srcMedium}
                                        width={1200}
                                        alt={image?.alt}
                                        sizes='
                                            (max-width: 768px) 100vw,
                                            50vw
                                        '
                                        className='cover'
                                    />
                                </Mask>

                                <div className='cf'></div>

                            </>
                        ) : (
                            <img src={assets.image} alt={assets.alt} title={assets.alt} className='draw' />
                        )}

                    </div>

                    {(isNonWhitespaceString(text) || isNonWhitespaceString(button.text)) && (
                        <div className='campaign-hero__bottom'>
                            <div className='row'>
                                <div className={clsx(image?.src ? 'col-md-10 col-xl-8' : 'col-md-10 offset-md-1 col-xl-8 offset-xl-2')}>
                                    <Mask className='content' bgColor='white' spacing='small'>

                                        {isNonWhitespaceString(text) && (
                                            <div
                                                className='text-big rich-text'
                                                dangerouslySetInnerHTML={{ __html: text }}
                                                suppressHydrationWarning
                                            />
                                        )}

                                        {isNonWhitespaceString(button.text) && (
                                            <Button
                                                href={button.href}
                                                hasBorders
                                                hover='blue-dark'
                                                noUnderline
                                                target={!!button.external}
                                                className='button--bottom'
                                            >
                                                {button.text}
                                            </Button>
                                        )}

                                    </Mask> 
                                </div>
                            </div>
                        </div>
                    )} 

                    {isNonWhitespaceString(video?.url) && (
                        <Mask>
                            <Video
                                className='video-wrapper'
                                video={{
                                    playButtonColor: bgColor,
                                    playText: video?.playText,
                                    playTextColor: 'white',
                                    videoType: video?.videoType,
                                    poster: video?.poster,
                                    posterMedium: video?.posterMedium,
                                    url: video?.url
                                }}
                            />
                        </Mask>
                    )}

                </div>
            </div>
        </Section>
    )
}